import {
	Component,
	OnInit,
	ChangeDetectorRef,
	HostListener,
	AfterViewInit,
	ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/services/global/global.service";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { FundingToken } from "src/app/models/dmv/fundingToken";
import { RouteFrom } from "src/app/models/routeFrom";
import { Registration } from "src/app/models/dmv/registration";
import { PaymentDetails } from "src/app/models/dmv/paymentDetails";
import {
	Address,
	ErrorDescriptionModel,
	ErrorLogRequest,
	ErrorRequest,
	TypeIDEnum
} from "src/app/models/dmv/models";
import { AddressChangeModelComponent } from "../../dmv/address-change-model/address-change-model.component";
import { DMVDataService } from "src/app/services/dmv/dmv-data.service";
import { Renewal } from "../../../models/dmv/renewal";
import { AppUtil } from "../../../utils/app.util";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { PaymentDevice } from "src/app/models/user/paymentDevice";
declare var window: any;

@Component({
	selector: "app-payment-details",
	templateUrl: "./payment-details.component.html",
	styleUrls: ["./payment-details.component.css"]
})
export class PaymentDetailsComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private formBuilder: FormBuilder,
		public userStoreService: USERStoreService,
		private cd: ChangeDetectorRef
	) {}

	public firstRegistration: Registration = null;
	public paymentUrl: string;
	public agencyConfig: AgencyDmvConfigResponse;
	public isloading: boolean = true;
	public errorMessage: string = "";
	public buttonLabel: string = "Continue";
	public reCallAccess: boolean;
	public fundingToken: string;
	public renewalRequest: Renewal = {};
	public iframeScrollHeight: number = 0;
	public paymentIframeURI: string = "vembed/payment-frame";

	public webComponentLoadTimeStart: number = null;
	public webComponentLoadTimeEnd: number = null;

	public webComponentTokenizationTimeStart: number = null;
	public webComponentTokenizationTimeEnd: number = null;
	public savedToProfile: boolean = false;
	public submitted = false;
	public saveToProfileForm: FormGroup;
	public reCallCounter: number = 0;

	@HostListener("window:resize", ["$event"])
	onResize(event) {
		const iframe = document.getElementById("payment-iframe");
		if (iframe) {
			const iframeWin = (<HTMLIFrameElement>iframe).contentWindow;
			const message = "recalculate";

			if (iframeWin) {
				iframeWin.postMessage(message, "*");
			}
		}
	}

	@HostListener("window:message", ["$event"])
	onMessage(message) {
		AppUtil.log("PaymentDetailsComponent window:message = ", message);
		if (message.data) {
			const outcomeCode: string = message.data.outcomeCode;
			const outcomeText: string = message.data.outcomeText;
			const messageData: any = message.data.data;
			const documentHeight: number = message.data.documentHeight;

			console.log("payment data:" + JSON.stringify(message.data));

			switch (message.data.action) {
				case "recalculateDocHeight":
					if (this.iframeScrollHeight !== documentHeight) {
						this.isloading = true;
						this.setHeight(documentHeight);
						this.isloading = false;
					}
					break;
				case "componentLoad":
					if (
						message.data.outcomeCode !== "0" &&
						message.data.outcomeCode !== 0
					) {
						const errorRequestData: ErrorLogRequest = {
							agencyID: this.agencyConfig.agencyDmvConfig.agencyID,
							errorDescription: {
								pageID: 8,
								typeID: "2",
								source: message.data.action,
								code: message.data.outcomeCode,
								text: message.data.outcomeText,
								dataField1: this.dmvStoreService.registrationsInCart.accessToken
							},
							sessionID: this.dmvStoreService.sessionID
						};
						this.postErrorLog(errorRequestData);
					}
					if (
						message.data.outcomeCode === "0" ||
						message.data.outcomeCode === 0
					) {
						this.webComponentLoadTimeEnd = new Date().getTime();
						this.reCallAccess = false;
						this.buttonLabel = "Continue";
						this.errorMessage = "";
					} else if (
						message.data.outcomeCode === "4" ||
						message.data.outcomeCode === 4
					) {
						if (this.reCallCounter === 0) {
							this.reCallAccess = true;
							this.reCallCounter++;
							this.continue();
						} else {
							this.buttonLabel = "Try Again";
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC:AT)";
							window.scrollTo(0, 0);
							this.reCallAccess = true;
						}
					} else {
						this.buttonLabel = "Try Again";
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText +
							" (EC: WC" +
							message.data.outcomeCode +
							")";
						window.scrollTo(0, 0);
						this.reCallAccess = false;
					}
					this.isloading = false;
					console.log("payment Page Loaded");
					this.setHeight(documentHeight);
					break;

				case "tokenization":
					this.isloading = true;
					this.errorMessage = "";
					this.webComponentTokenizationTimeEnd = new Date().getTime();
					const errorRequest = new ErrorRequest();
					errorRequest.errorField1 = message.data.outcomeCode;
					errorRequest.errorField2 = message.data.outcomeText;
					errorRequest.errorField3 = JSON.stringify(message.data.data);
					if (
						message.data.outcomeCode === "0" ||
						message.data.outcomeCode === 0
					) {
						if (
							!messageData.token ||
							(messageData.token && messageData.token.length === 0)
						) {
							const errorRequestData: ErrorLogRequest = this.createErrorRequest(
								8,
								"2",
								message.data.action,
								message.data.outcomeCode,
								message.data.outcomeText
							);
							this.postErrorLog(errorRequestData);
						}
						this.updatedPaymenetDetails(messageData);
						this.dmvStoreService.registrationsInCart.renewalRequest.fundingToken = this.dmvStoreService.paymentDetails.fundingToken.fundingToken;
						this.reCallAccess = false;
						this.getFundingToken(
							this.dmvStoreService.paymentDetails,
							this.agencyConfig.agencyDmvConfig.agencyID
						);
					} else if (
						message.data.outcomeCode === "4" ||
						message.data.outcomeCode === 4
					) {
						this.reCallAccess = true;
						this.errorMessage = this.getErrorMessage(outcomeCode, outcomeText);
						window.scroll(0, 0);
						this.isloading = false;
					} else {
						this.buttonLabel = "Try Again";
						this.errorMessage = this.getErrorMessage(outcomeCode, outcomeText);
						this.reCallAccess = false;
						window.scroll(0, 0);
						this.isloading = false;
					}

					if (Number(message.data.outcomeCode) > 2) {
						const errorRequestData: ErrorLogRequest = this.createErrorRequest(
							8,
							"2",
							message.data.action,
							message.data.outcomeCode,
							message.data.outcomeText
						);
						this.postErrorLog(errorRequestData);
					}
					break;
				default:
				// code block
			}
			this.iframeScrollHeight = message.data.documentHeight;
		}
	}
	public postErrorLog(request) {
		this.dmvDataService.postErrorLogRequest(request).subscribe(response => {
			if (response) {
				AppUtil.log(
					"PaymentDetailsComponent postErrorLog() ==>  response: ",
					response
				);
			}
		});
	}

	public createErrorRequest(
		inPage: number,
		inType: TypeIDEnum,
		inSource: string,
		inCode: number,
		inText: string
	) {
		const errorRequestData: ErrorLogRequest = {
			agencyID: this.agencyConfig.agencyDmvConfig.agencyID,
			errorDescription: {
				pageID: inPage,
				typeID: inType,
				source: inSource,
				code: inCode,
				text: inText,
				dataField1: this.dmvStoreService.registrationsInCart.accessToken
			},
			sessionID: this.dmvStoreService.sessionID
		};
		return errorRequestData;
	}

	public postError(request) {
		request.errorField4 =
			this.webComponentTokenizationTimeEnd -
			this.webComponentTokenizationTimeStart;
		request.errorField5 = "";
		request.errorID = 1;

		this.dmvDataService
			.postErrorResponse(
				request,
				this.agencyConfig.agencyDmvConfig.agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(response => {
				if (response) {
					AppUtil.log(
						"PaymentDetailsComponent getErrorResponse() ==>  response: ",
						response
					);
				}
			});
	}

	public getFundingToken(paymentDetails: PaymentDetails, agencyID) {
		let shortName = null;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.savedToProfile
		) {
			shortName = this.saveToProfileForm.controls.shortName.value;
			paymentDetails.fundingToken.addToProfile = true;
			paymentDetails.fundingToken.shortName = shortName;
		}
		AppUtil.log(
			"PaymentDetailsComponent getFundingToken() ==>  PaymentDetails, agencyID",
			paymentDetails,
			agencyID
		);
		const webComponentLoadTime =
			this.webComponentLoadTimeEnd - this.webComponentLoadTimeStart;
		const webComponentTokenizationTime =
			this.webComponentTokenizationTimeEnd -
			this.webComponentTokenizationTimeStart;
		this.dmvDataService
			.getFundingTokenResponse(
				paymentDetails.fundingToken,
				agencyID,
				this.dmvStoreService.sessionID,
				webComponentLoadTime,
				webComponentTokenizationTime
			)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent getFundingToken() ==>  response: ",
						response
					);
					if (response) {
						// this.isloading = false;
						this.fundingToken = paymentDetails.fundingToken.fundingToken;
						this.renewalRequest.fundingToken =
							paymentDetails.fundingToken.fundingToken;

						if (
							this.userStoreService.getUserProfile() &&
							this.userStoreService.getUserProfile().megUserGUID
						) {
							this.userStoreService.saveToProfile = this.savedToProfile;
							const userProfile = this.userStoreService.getUserProfile();
							userProfile.paymentDevices = response.userProfile.paymentDevices;
							this.userStoreService.setUserProfile(userProfile);
						} else {
							this.userStoreService.saveToProfile = false;
						}

						this.callRenewApi(
							this.dmvStoreService.registrationsInCart.renewalRequest,
							this.agencyConfig.agencyDmvConfig.agencyID
						);
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent getFundingToken() ==>  error: ",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + "(EC: FT) ";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public callRenewApi(renewalRequest, agencyID) {
		AppUtil.log(
			"PaymentDetailsComponent callRenewApi() ==>  renewalRequest, agencyID: ",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getRenewalResponse(
				renewalRequest,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					if (response) {
						AppUtil.log(
							"PaymentDetailsComponent callRenewApi() ==>  response: ",
							response
						);
						if (response.statusCode === 202) {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC: RNC)";
							this.isloading = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						} else {
							this.dmvStoreService.registrationsInCart.renewalToken =
								response.renewalToken;
							this.getServiceFees();
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent callRenewApi() ==>  error: ",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: RNC)";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
	public get f() {
		return this.saveToProfileForm.controls;
	}
	ngOnInit() {
		AppUtil.log("PaymentDetailsComponent ngOnInit() ==> ");

		this.buttonLabel = "Continue";
		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.agencyConfig = agencyConfig;
					this.isloading = true;
					this.callPaymentAccessToken(
						this.dmvStoreService.registrationsInCart.renewalRequest,
						this.agencyConfig.agencyDmvConfig.agencyID
					);
					if (
						this.userStoreService.getUserProfile() &&
						this.userStoreService.getUserProfile().megUserGUID &&
						this.agencyConfig.agencyDmvConfig.reusableFundingToken
					) {
						//	this.savedToProfile = this.userStoreService.saveToProfile;
						this.saveToProfileForm = this.formBuilder.group({
							shortName: ["", [Validators.maxLength(20)]]
						});
					}
				}
			})
			.unsubscribe();

		//this.initiatePaymentComponent();
	}

	public initiatePaymentComponent() {
		AppUtil.log("PaymentDetailsComponent initiatePaymentComponent() ==> ");
		this.isloading = true;

		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			this.firstRegistration = this.dmvStoreService.registrationsInCart.dmvRegistrations[0].registration;
		}
		const paymentUrl = "";
		let paymentUri = "";

		const userProfile = this.userStoreService.getUserProfile();
		let data: PaymentDevice = null;
		if (userProfile && userProfile.contactInfo) {
			data = {
				emailAddress: userProfile.contactInfo.emailAddress,
				phone: userProfile.contactInfo.phoneNumber
			};
		} else if (this.globalService.supportKioskPickup) {
			data = {
				emailAddress: this.dmvStoreService.registrationsInCart.pickupInPerson
					.email,
				phone: this.dmvStoreService.registrationsInCart.pickupInPerson.phone
			};
		}
		if (this.dmvStoreService.paymentDetails) {
			this.updatePaymenetDetails(data);
			paymentUri = this.getPaymentURI(
				this.dmvStoreService.paymentDetails,
				this.agencyConfig.agencyDmvConfig.agencyID
			);
		} else {
			if (this.firstRegistration) {
				this.populatePaymenetDetails(data);
				paymentUri = this.getPaymentURI(
					this.dmvStoreService.paymentDetails,
					this.agencyConfig.agencyDmvConfig.agencyID
				);
			} else {
				paymentUri =
					"agencyid=" +
					this.agencyConfig.agencyDmvConfig.agencyID +
					"&accesstoken=" +
					this.dmvStoreService.registrationsInCart.accessToken +
					"&paymentDescriptor=" +
					this.agencyConfig.agencyDmvConfig.paymentDescriptor +
					"&firstName=" +
					"&lastName=" +
					"&addressLine1=" +
					"&addressLine2=" +
					"&stateCode=" +
					"&postalCode=" +
					"&billingEmailAddress=" +
					(data ? data.emailAddress : "") +
					"&billingPhone=" +
					(data ? data.phone : "") +
					"&city=";
			}
		}

		this.paymentUrl =
			this.agencyConfig.agencyDmvConfig.providerWebCompURL +
			this.paymentIframeURI +
			"?" +
			paymentUri +
			"&time=" +
			new Date().getTime();

		this.cd.markForCheck();
		if (this.reCallAccess) {
			const iframe = document.getElementById("payment-iframe");
			const iframeWin = <HTMLObjectElement>iframe;
			iframeWin.data = this.paymentUrl;
			this.reCallAccess = false;
			this.errorMessage = "";
		}

		AppUtil.log(
			"PaymentDetailsComponent initiatePaymentComponent() ==> this.paymentUrl ",
			this.paymentUrl
		);
	}

	public updatePaymenetDetails(data: PaymentDevice) {
		if (this.dmvStoreService.paymentDetails.fundingToken && data) {
			this.dmvStoreService.paymentDetails.fundingToken.billingPhone =
				data.phone;
		}
		if (this.dmvStoreService.paymentDetails.fundingToken && data) {
			this.dmvStoreService.paymentDetails.fundingToken.billingEmailAddress =
				data.emailAddress;
		}
	}
	public setHeight(documentHeight: any) {
		const iframe = document.getElementById("payment-iframe");
		console.log("documentHeight : original setHeight =>" + documentHeight);

		//There are times, when the height is not calculated correctly em or px
		let explicitPx = true;
		//const iframeWin = (<HTMLObjectElement>iframe).contentWindow;
		//const iframeWinHeight = iframeWin.document.body.scrollHeight;
		let iframeWinHeight = 1050;
		let pxOrEm = "";
		if (documentHeight) {
			iframeWinHeight = documentHeight;

			if (documentHeight < 350) {
				explicitPx = false;
				pxOrEm = iframeWinHeight + 10 + "em";
			} else {
				pxOrEm = iframeWinHeight + 40 + "px";
			}
		}

		this.globalService.logBrowserDetails();

		// if (this.globalService.browserDetails.isMobile) {
		// 	pxOrEm = iframeWinHeight + 8 + "em";
		// } else {
		// 	pxOrEm = iframeWinHeight + 40 + "px";
		// }

		//fix for safari browser
		/*if (
			this.globalService.browserDetails &&
			this.globalService.browserDetails.name.indexOf("Safari") >= 0 &&
			!explicitPx
		) {
			if (this.globalService.browserDetails.isMobile) {
				pxOrEm = iframeWinHeight + 10 + "em";
			} else {
				pxOrEm = iframeWinHeight / 2 - 3 + "em";
			}
		}

		if (
			this.globalService.browserDetails &&
			this.globalService.browserDetails.name.indexOf("Edge") >= 0
		) {
			pxOrEm = "1200px";
		}

		if (
			this.globalService.browserDetails &&
			this.globalService.browserDetails.name.indexOf("Edge") >= 0 && 
			this.globalService.browserDetails.isMobile
		) {
			pxOrEm = "1950px";
		}

		if (
			this.globalService.browserDetails &&
			this.globalService.browserDetails.name.indexOf("Chrome") >= 0 &&
			this.globalService.browserDetails.isTablet
		) {
			pxOrEm = "1100px";
		}*/

		document.getElementById("payment-iframe").style.height = pxOrEm;
		console.log(
			"documentHeight : setHeight =>" +
				document.getElementById("payment-iframe").style.height
		);
	}
	public iframeLoad(message) {
		AppUtil.log("PaymentDetailsComponent iframeLoad() ==>");
		this.isloading = false;
	}
	public goBack() {
		const _this = this;
		AppUtil.log("PaymentDetailsComponent goBack() ==>");
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.userStoreService.getUserProfile().paymentDevices &&
			this.userStoreService.getUserProfile().paymentDevices.length > 0 &&
			this.userStoreService
				.getUserProfile()
				.paymentDevices.filter(function(item) {
					return (
						Number(_this.dmvStoreService.selectedAgencyId) === item.agencyID
					);
				}).length > 0
		) {
			this.router.navigate(["select-payment-method"], {
				skipLocationChange: true
			});
		} else {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.from = "payment";
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		}
	}
	public save() {
		this.errorMessage = "";
		this.submitted = true;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.saveToProfileForm &&
			this.saveToProfileForm.invalid &&
			this.agencyConfig.agencyDmvConfig.reusableFundingToken
		) {
			this.errorMessage = "Please correct fields in error.";
			console.log("saveToProfileForm.invalid");
			return;
		}
		this.continue();
	}

	public continue() {
		AppUtil.log("PaymentDetailsComponent continue() ==>");
		this.errorMessage = "";
		if (this.reCallAccess) {
			AppUtil.log("PaymentDetailsComponent callPaymentAccessToken() ==>");
			this.callPaymentAccessToken(
				this.dmvStoreService.registrationsInCart.renewalRequest,
				this.agencyConfig.agencyDmvConfig.agencyID
			);
		} else {
			this.isloading = true;
			this.errorMessage = "";
			window.scrollTo(0, 0);
			const iframe = document.getElementById("payment-iframe");
			const iframeWin = (<HTMLIFrameElement>iframe).contentWindow;
			// if( iframeWin.document && iframeWin.document.activeElement ) {
			// 	iframeWin.document.activeElement.blur();
			// }
			const message = "tokenization";

			if (iframeWin) {
				this.webComponentTokenizationTimeStart = new Date().getTime();
				iframeWin.postMessage(message, "*");
			} else {
				this.isloading = false;
				this.errorMessage =
					"Sorry, your browser is not supported, please use chrome or safari to access this page..";
				window.scrollTo(0, 0);
			}
		}
	}

	public callPaymentAccessToken(renewalRequest, agencyID) {
		AppUtil.log(
			"PaymentDetailsComponent callPaymentAccessToken() ==> renewalRequest, agencyID :",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getPaymentAccessTokenResponse(agencyID, this.dmvStoreService.sessionID)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent callPaymentAccessToken() ==> response :",
						response
					);
					if (response) {
						if (response.accessToken) {
							this.webComponentLoadTimeStart = new Date().getTime();
							this.dmvStoreService.registrationsInCart.accessToken =
								response.accessToken;
							this.initiatePaymentComponent();
							// this.isloading = true;
							// this.errorMessage = "";
							// const iframe = document.getElementById("payment-iframe");
							// const iframeWin = (<HTMLIFrameElement>iframe).contentWindow;
							// const message = "tokenization";

							// if (iframeWin) {
							// 	iframeWin.postMessage(message, "*");
							// }
							this.cd.markForCheck();
						} else {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC:AT)";

							window.scrollTo(0, 0);
							this.isloading = false;
							this.buttonLabel = "Try Again";
							this.reCallAccess = true;
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent callPaymentAccessToken() ==> error :",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC:AT)";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.buttonLabel = "Try Again";
						this.reCallAccess = true;
						this.cd.markForCheck();
					}
				}
			);
	}

	private populatePaymenetDetails(data: PaymentDevice) {
		AppUtil.log("PaymentDetailsComponent populatePaymenetDetails() ==> ");
		const paymentDetails: PaymentDetails = new Object({});
		const fundingToken: FundingToken = new Object({});
		fundingToken.billingAddress = new Object({});

		//const firstName = this.firstRegistration.registrantName;
		if (data && data.phone) {
			fundingToken.billingPhone = data.phone;
		}
		if (data && data.emailAddress) {
			fundingToken.billingEmailAddress = data.emailAddress;
		}

		let addressLine1 = this.firstRegistration.registrantAddress.line1;
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			fundingToken.billingAddress.line1 = addressLine1;
		}

		let addressLine2 = this.firstRegistration.registrantAddress.line2;
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			fundingToken.billingAddress.line2 = addressLine2;
		}

		const stateCode = this.firstRegistration.registrantAddress.stateCode;
		if (stateCode) {
			fundingToken.billingAddress.stateCode = stateCode;
		}

		const postalCode = this.firstRegistration.registrantAddress.postalCode;
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.billingAddress.postalCode = postalCode;
		}

		const city = this.firstRegistration.registrantAddress.city;
		if (city) {
			fundingToken.billingAddress.city = city;
		}

		const countryCode = this.firstRegistration.registrantAddress.countryCode;
		if (countryCode) {
			fundingToken.billingAddress.countryCode = countryCode;
		}

		if (countryCode !== "US" && stateCode) {
			fundingToken.billingAddress.nonUsRegion = stateCode;
		}

		paymentDetails.fundingToken = fundingToken;
		this.dmvStoreService.paymentDetails = paymentDetails;
		AppUtil.log(
			"PaymentDetailsComponent populatePaymenetDetails() ==> paymentDetails: ",
			paymentDetails
		);
	}

	private updatedPaymenetDetails(data: any) {
		AppUtil.log(
			"PaymentDetailsComponent updatedPaymenetDetails() ==> data: ",
			data
		);
		const paymentDetails: PaymentDetails = new Object({});
		const fundingToken: FundingToken = new Object({});
		fundingToken.billingAddress = new Object({});
		//paymentDetails.fundingToken = new Object({});
		const firstName = data.firstName;
		if (firstName) {
			fundingToken.billingFirstName = firstName;
		}

		const lastName = data.lastName;
		if (lastName) {
			fundingToken.billingLastName = lastName;
		}

		let addressLine1 = data.addressLine1;
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			fundingToken.billingAddress.line1 = addressLine1;
		}

		let addressLine2 = data.addressLine2;
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			fundingToken.billingAddress.line2 = addressLine2;
		}

		const stateCode = data.stateCode;
		if (stateCode) {
			fundingToken.billingAddress.stateCode = stateCode;
		}
		const nonUsRegion = data.nonUsRegion;
		if (nonUsRegion) {
			fundingToken.billingAddress.nonUsRegion = nonUsRegion;
		}

		const postalCode = data.postalCode;
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.billingAddress.postalCode = postalCode;
		}

		const city = data.city;
		if (city) {
			fundingToken.billingAddress.city = city;
		}

		const country = data.countryCode;
		if (country) {
			fundingToken.billingAddress.countryCode = country;
		}

		const last4 = data.last4 ? data.last4 : "";
		if (last4) {
			fundingToken.accountLast4 = last4;
		}

		const nameOnAccount = data.nameOnAccount;
		if (nameOnAccount) {
			fundingToken.nameOnAccount = nameOnAccount;
		}

		const phone = data.phone;
		if (phone) {
			fundingToken.billingPhone = phone;
		}

		const emailAddress = data.emailAddress;
		if (emailAddress) {
			fundingToken.billingEmailAddress = emailAddress;
		}

		const paymentMethod = data.paymentMethod;
		if (paymentMethod) {
			fundingToken.paymentMethod = paymentMethod;
		}

		const expiration = data.expiration;
		if (expiration) {
			fundingToken.expiration = expiration;
		}

		const cardBrand = data.cardBrand;
		if (cardBrand) {
			fundingToken.cardBrand = cardBrand;
		} else {
			if (paymentMethod === "Electronic Check") {
				fundingToken.cardBrand = "EC";
			}
		}

		const token = data.token;
		if (token) {
			fundingToken.fundingToken = token;
		}

		paymentDetails.fundingToken = fundingToken;
		this.dmvStoreService.paymentDetails = paymentDetails;
		AppUtil.log(
			"PaymentDetailsComponent updatedPaymenetDetails() ==> paymentDetails: ",
			paymentDetails
		);
	}

	private getPaymentURI(
		paymentDetails: PaymentDetails,
		agencyId: string
	): string {
		AppUtil.log(
			"PaymentDetailsComponent getPaymentURI() ==> paymentDetails agencyId ",
			paymentDetails,
			agencyId
		);
		let paymentUrl = "";
		if (agencyId) {
			paymentUrl = "agencyid=" + agencyId;
		}

		if (this.agencyConfig.agencyDmvConfig.paymentDescriptor) {
			paymentUrl =
				paymentUrl +
				"&paymentDescriptor=" +
				encodeURIComponent(this.agencyConfig.agencyDmvConfig.paymentDescriptor);
		}

		const fundingToken: FundingToken = paymentDetails.fundingToken;

		let accessToken = paymentDetails.accessToken;
		accessToken = this.dmvStoreService.registrationsInCart.accessToken;
		if (accessToken) {
			paymentUrl = paymentUrl + "&accesstoken=" + accessToken;
		}

		const firstName = fundingToken.billingFirstName;
		if (firstName) {
			paymentUrl = paymentUrl + "&firstName=" + encodeURIComponent(firstName);
		}

		const lastName = fundingToken.billingLastName;
		if (lastName) {
			paymentUrl = paymentUrl + "&lastName=" + encodeURIComponent(lastName);
		}

		let addressLine1 = fundingToken.billingAddress.line1;
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			paymentUrl =
				paymentUrl + "&addressLine1=" + encodeURIComponent(addressLine1);
		}

		let addressLine2 = fundingToken.billingAddress.line2;
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			paymentUrl =
				paymentUrl + "&addressLine2=" + encodeURIComponent(addressLine2);
		}

		let countryCode = fundingToken.billingAddress.countryCode;
		if (countryCode) {
			paymentUrl =
				paymentUrl + "&countryCode=" + encodeURIComponent(countryCode);
		} else {
			countryCode = "US";
			paymentUrl =
				paymentUrl + "&countryCode=" + encodeURIComponent(countryCode);
		}

		const stateCode = fundingToken.billingAddress.stateCode;
		if (stateCode && countryCode === "US") {
			paymentUrl = paymentUrl + "&stateCode=" + encodeURIComponent(stateCode);
		}

		const nonUsRegion = fundingToken.billingAddress.nonUsRegion;
		if (nonUsRegion && countryCode !== "US") {
			paymentUrl =
				paymentUrl + "&nonUsRegion=" + encodeURIComponent(nonUsRegion);
		}

		const postalCode = fundingToken.billingAddress.postalCode;
		if (postalCode) {
			paymentUrl = paymentUrl + "&postalCode=" + encodeURIComponent(postalCode);
		}

		const city = fundingToken.billingAddress.city;
		if (city) {
			paymentUrl = paymentUrl + "&city=" + encodeURIComponent(city);
		}

		const phone = fundingToken.billingPhone;
		if (phone) {
			paymentUrl = paymentUrl + "&phone=" + phone;
		}

		const emailAddress = fundingToken.billingEmailAddress;
		if (emailAddress) {
			paymentUrl =
				paymentUrl + "&emailAddress=" + encodeURIComponent(emailAddress);
		}
		AppUtil.log(
			"PaymentDetailsComponent getPaymentURI() ==> paymentUrl: ",
			paymentUrl
		);
		return paymentUrl;
	}

	public getServiceFees() {
		AppUtil.log("PaymentDetailsComponent getServiceFees() ==>");
		const renewalToken = this.dmvStoreService.registrationsInCart.renewalToken;
		const agencyID = this.agencyConfig.agencyDmvConfig.agencyID;
		this.dmvDataService
			.getServiceFeesResponse(
				renewalToken,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent getServiceFees() ==> response",
						response
					);
					if (response) {
						this.isloading = false;
						this.cd.markForCheck();
						this.dmvStoreService.registrationsInCart.serviceFeeAmount =
							response.serviceFeeAmount;

						this.router.navigate(["dmv-review-cart-with-billing"], {
							skipLocationChange: true
						});
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent getServiceFees() ==> error",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: FEE)";
						this.isloading = false;
						this.cd.markForCheck();
						window.scroll(0, 0);
					}
				}
			);
	}

	public getDetailToSaveInProfile(data: PaymentDetails) {
		const obj: PaymentDevice = Object.assign({});
		obj.agencyID = Number(this.agencyConfig.agencyDmvConfig.agencyID);
		obj.cardBrand = data.fundingToken.cardBrand;
		obj.emailAddress = data.fundingToken.billingEmailAddress;
		obj.firstName = data.fundingToken.billingFirstName;
		obj.lastName = data.fundingToken.billingLastName;
		obj.fundingToken = data.fundingToken.fundingToken;
		obj.nameOnAccount = data.fundingToken.nameOnAccount;
		obj.paymentMethod = data.fundingToken.paymentMethod;
		obj.phone = data.fundingToken.billingPhone;
		obj.shortName = data.fundingToken.shortName;

		let type;
		if (data.fundingToken.cardBrand === "VI") {
			type = "Visa";
		}
		switch (data.fundingToken.cardBrand) {
			case "VI": {
				type = "Visa";
				break;
			}
			case "MC": {
				type = "MasterCard";
				break;
			}
			case "AE": {
				type = "AmericanExpress";
				break;
			}
			case "DI": {
				type = "Discover";
				break;
			}
			default:
		}
		obj.type = type;
		obj.accountLast4 = data.fundingToken.accountLast4;
		obj.address = data.fundingToken.billingAddress;

		return obj;
	}

	private getErrorMessage(outcomeCode: string, outcomeText: string): string {
		let errorMessage: string = "";
		switch (outcomeCode) {
			case "1": {
				errorMessage =
					"Please correct all errors indicated below before continuing.";
				break;
			}
			default:
				errorMessage = outcomeText;
		}
		return errorMessage;
	}

	public savedToProfileChange(event) {
		AppUtil.log("PaymentDetailsComponent savedToProfileChange() ==>");
		this.savedToProfile = event.target.checked;
	}
}
